import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

const TeamInfo = ({ outcome, scoreClass, isRight, isWinner }) => {
  const spread = parseFloat(outcome.spread);
  const isUnderdog = spread > 0;

  return (
    <div className={`flex flex-col space-y-1 ${isRight ? 'items-end' : 'items-start'}`}>
      <div className="flex items-center gap-2">
        <span className={`font-bold text-sm tracking-wide ${isWinner ? 'text-accent' : 'text-foreground'}`}>
          {outcome.team}
        </span>
        {isWinner && <TrendingUp className="w-3 h-3 text-accent" />}
      </div>
      <span className={scoreClass}>{outcome.score}</span>
      <div className="flex items-center gap-1">
        {isUnderdog ? (
          <TrendingUp className="w-3 h-3 text-muted-foreground" />
        ) : (
          <TrendingDown className="w-3 h-3 text-muted-foreground" />
        )}
        <span className="text-xs text-muted-foreground font-medium">
          {spread > 0 ? `+${spread}` : spread}
        </span>
      </div>
    </div>
  );
};

export default TeamInfo;
